var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isCompany === true)?_c('document-request-detail-corporation',{attrs:{"visible":true},on:{"close":_vm.close}}):(_vm.isCompany === false)?_c('document-request-detail-individual',{attrs:{"visible":true},on:{"close":_vm.close}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }